import DefaultRenderer from './default';
import Swiper from 'swiper';
import gallerySlider from '../../components/gallery-slider';
import gsap from 'gsap';

class capabilities extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		let mainScroll = this.mainController.getScroll();

		// Innovation Centers
		gsap.to(document.getElementsByClassName('innovation-point'), {
			duration: 1.5,
			autoAlpha: 1,
			ease: 'power4.out',
			stagger: 0.1,
		});

		let offerSlider = new Swiper('#research-slider', {
			init: false,
			slidesPerView: 1,
			spaceBetween: 24,
			centeredSlides: true,
			freeMode: true,
			freeModeMomentum: true,
			breakpoints: {
				// when window width is <= 480px
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
			grabCursor: true,
			loop: true,
			pagination: {
				el: '.research-pagination',
				clickable: true,
			},
		});

		offerSlider.init();

		mainScroll.on('scroll', instance => {
			offerSlider.setTranslate(-instance.scroll.y / 3);
		});

		// Solutions Gallery
		let navigationButtons = [
			document.getElementsByClassName('swiper-button-prev')[0],
			document.getElementsByClassName('swiper-button-next')[0],
		];

		gallerySlider('#mediacenter-gallery', navigationButtons, mainScroll);

		// Software Cards
		let activeItem = document.getElementById('active-item');

		// Card Animation
		let cardAnimation = {
			timeline: gsap.timeline(),
			isActive: () => {
				cardAnimation.timeline.isActive();
			},
			play: target => {
				let activeCard = document.querySelector('.card-item.active'),
					secondCard = document.querySelector('.card-item.second'),
					thirdCard = document.querySelector('.card-item.third');

				// Change card content
				secondCard.getElementsByTagName('h4')[0].innerHTML = target.getElementsByTagName('span')[0].innerHTML;
				secondCard.getElementsByTagName('ul')[0].innerHTML = target.getElementsByTagName('ul')[0].innerHTML;

				cardAnimation.timeline
					.to(activeCard, {
						duration: 0.3,
						y: -activeCard.getBoundingClientRect().height,
						rotation: 5,
						ease: 'back.in(1.7)',
						onComplete: () => {
							// Third Card
							thirdCard.className = 'card-item second';
							// Second Card
							secondCard.className = 'card-item active';
							activeCard.style.zIndex = '0';
						},
					})
					.to(activeCard, 0.6, {
						y: 28,
						rotation: 0,
						scale: 0.9,
						ease: 'power4.inOut',
						onComplete: () => {
							activeCard.className = 'card-item third';
							gsap.set(activeCard, {
								clearProps: 'all',
							});
						},
					});
			},
		};

		// -- Item List Selector
		let softwareItems = document.getElementsByClassName('software-item');
		for (let index = 0; index < softwareItems.length; index++) {
			const softwareItem = softwareItems[index];

			softwareItem.addEventListener('click', function() {
				if (this.classList.contains('active') || cardAnimation.timeline.isActive()) {
					return;
				}

				let targetIndex = parseInt(this.dataset.item),
					allItems = this.parentNode.getElementsByClassName('software-item');

				// Remove all active classes for siblings
				for (let index = 0; index < allItems.length; index++) {
					const item = allItems[index];
					if (this !== item) {
						item.classList.remove('active');
					}
				}

				// add active for clicked item
				this.classList.add('active');

				gsap.to(activeItem, {
					duration: 0.3,
					y: targetIndex * 46,
					ease: 'back.out(1.4)',
				});

				cardAnimation.play(this);
			});
		}
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default capabilities;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/capabilities.js